import axios from "axios";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../context";

type TOrderOfFacilitatorNotification = 1 | 2 | 3 | 4 | 5 | 6;

interface ICallTheFacilitatorOption {
    orderOfFacilitatorNotification: TOrderOfFacilitatorNotification;
    key: number
}

const CallTheFacilitatorOption: FC<ICallTheFacilitatorOption> = ({orderOfFacilitatorNotification, key}) => {
    const { t } = useTranslation();
    const { userData } = useContext(UserContext);
    const { setNotificationAlert, setActivateAlert } = useContext(UserContext);

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    const facilitatorNotificationTextDic = {
        1: t("ifYouNeddHelpYouCanCallText"),
        2: t("playerWantsToJoinText"),
        3: t("playerHasLoggedOutTheGameText"),
        4: t("platerHasLeftTheGameText"),
        5: t("aNetworkProblemHasOccuredText"),
        6: t("plateyHasSentYouAQuestionText")
    }

    const getFacilitatorNotificationStyle = () => {
        if (orderOfFacilitatorNotification === 1) return "first_facilitator_notification";
        return "rest_facilitator_notifications";
    }
    

    const callTheFacilitatorLearning = (notificationType: string) => {
        setNotificationAlert({message: t("notificationSentTofacilitatorText"), type:"facilitatorNotification"});
        setActivateAlert(true);

        axios({
            method: "post",
            url: process.env.REACT_APP_BACKEND_URL + "api/notification/notifyFacilitator",
            data: {
                matchId: urlTokenExtracted,
                player: userData?.email || "",
                notificationType: notificationType
            }
            })
            .then((res: any) => {
                console.log("Learning: ", res);
            })
            .catch((err: any) => console.error(err));
    }

    const facilitatorGreetingNotification = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} >
                {t("hiText")} {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const playerWantsToJoin = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} onClick={() => callTheFacilitatorLearning("WANTS_TO_JOIN")}>
                {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const playerHasLoggedOutOfTheGame = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} onClick={() => callTheFacilitatorLearning("LOGGED_OUT")}>
                {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const PlayerhasLeftTheGame = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} onClick={() => callTheFacilitatorLearning("PLAYER_LEFT")}>
                {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const aNetworkProblemHasOccured = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} onClick={() => callTheFacilitatorLearning("NETWORK_ISSUE")}>
                {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const playerHasSentYouAQuestion = () => {
        return(
            <div key={key} className={getFacilitatorNotificationStyle()} onClick={() => callTheFacilitatorLearning("QUESTION")}>
                {facilitatorNotificationTextDic[orderOfFacilitatorNotification]}
            </div>
        )
    }

    const orderOfFacilitatorNotificationDic = {
        1: facilitatorGreetingNotification(),
        2: playerWantsToJoin(),
        3: playerHasLoggedOutOfTheGame(),
        4: PlayerhasLeftTheGame(),
        5: aNetworkProblemHasOccured(),
        6: playerHasSentYouAQuestion()
    }

    return (
        <div className="call_the_facilitator_option_wrapper">
            {orderOfFacilitatorNotificationDic[orderOfFacilitatorNotification]}
        </div>
    )
}

export default CallTheFacilitatorOption;